var sin;
if (!sin) {
    sin = {};
}

$.extend(sin,
    /**
     * @lends sin
     */
    {
        /**
         * @namespace
         * @description slider
         */
        slider_oneSlide: {
            _obj: null,
            _selector: '.swiper--oneSlide',
            _config: {
                loop: false,
                slidesPerView: 1,
                preloadImages: false,
                lazy: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
            
            /**
             * @type {function}
             * @description initialize News Slider
             */
            init: function () {               
                sin.slider_oneSlide._obj = new Swiper(sin.slider_oneSlide._selector, sin.slider_oneSlide._config);
            }
        }
    }
);

$(sin.slider_oneSlide.init);
